// extracted by mini-css-extract-plugin
export default {"card":"product_card__4Gjk9","active":"product_active__S4IXC"};